import React from "react";

import { Box, Tooltip } from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";

export default function Info({ children, tooltip }) {
  return (
    <Box component="span" marginLeft={0.5}>
      <Tooltip title={tooltip}>
        {children || <HelpOutline color="action" fontSize="inherit" />}
      </Tooltip>
    </Box>
  );
}
